import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useSalutations = () => {
	const salutations = useSelector((state) => state.masterData.salutations);
	const [salutationOptions, setSalutationOptions] = useState([]);
	const [t] = useTranslation();

	useEffect(() => {
		if (salutations) {
			const salutationCopy = [...salutations];

			const newSalutations = salutationCopy.map((item) => {
				let newItem = {};
				newItem.value = item.user_salutation_id;
				if (item.lang_iso_code == 'translation') {
					newItem.text = t(
						'master_data.user_salutation.' + item.salutation_i18n_key
					);
				} else {
					newItem.text = item.salutation_i18n_key;
				}
				return newItem;
			});
			setSalutationOptions([
				{ value: '', text: t('common.anrede') + '*' },
				...newSalutations,
			]);
		}
	}, [salutations]);

	return salutationOptions;
};

export default useSalutations;
